import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import type { Product } from '../data/products';
type MaterialCatalogCardProps = {
  product: Product;
  categoryName: string;
  isBestSeller: boolean;
  index: number;
};
export function MaterialCatalogCard({
  product,
  categoryName,
  isBestSeller,
  index
}: MaterialCatalogCardProps) {
  return <motion.div layout initial={{
    opacity: 0,
    y: 12
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.22,
    delay: Math.min(index, 5) * 0.035
  }} data-id="element-1276" data-mp="24i1j849j9owp">
      <Link to={`/shop/${product.slug}`} className="group relative block h-[13.2rem] overflow-hidden rounded-lg border border-stone-200 bg-stone-200 shadow-sm transition-shadow focus:outline-none focus-visible:ring-2 focus-visible:ring-[#04A05C] focus-visible:ring-offset-2 hover:shadow-md sm:h-48 dark:border-white/10 dark:bg-white/10 dark:focus-visible:ring-offset-[#131413]" aria-label={`View ${product.name}, from ${product.pricePerYard} per yard`} data-id="element-1277" data-mp="20j2eokrpru5s">
        <img src={product.images?.[0] || product.image} alt="" loading={index < 3 ? 'eager' : 'lazy'} decoding="async" className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.04]" data-id="element-1278" data-mp="2wfj2bj8jbtqk" />
        {isBestSeller && <span className="absolute left-0 top-4 px-2.5 py-1.5 text-[11px] font-bold uppercase tracking-wide shadow-sm text-[#fffff9] bg-[#006239]" data-id="element-1279" data-mp="3a5mjvwwgyz9o">Best Seller</span>}
        <div className="absolute inset-x-0 bottom-0 flex items-end justify-between gap-3 bg-[#FBFCFB] px-3 py-2.5 text-stone-650 sm:px-4 dark:bg-black/65 dark:text-white dark:backdrop-blur-[1px]" data-id="element-1280" data-mp="3f4hctro5i47i">
          <div className="min-w-0 font-sub" data-id="element-1281" data-mp="3p3oo89bbrorz">
            <p className="truncate text-[9px] uppercase tracking-[0.12em] text-stone-900 dark:text-white/80 font-[400] font-[Cabin,_sans-serif]" data-id="element-1282" data-mp="3t48ovmv3xaiv">{categoryName}</p>
            <h3 className="mt-0.5 truncate sm:text-base font-[Cabin,_sans-serif] font-[500] text-[14px]" data-id="element-1283" data-mp="1uqyvvw0lunmp">{product.name}</h3>
          </div>
          <p className="shrink-0 font-[Cabin,_sans-serif] font-[500] text-[12px]" data-id="element-1284" data-mp="320v7f2h7fy3k">${product.pricePerYard}<span className="ml-0.5 text-xs font-semibold text-stone-700 dark:text-white/55" data-id="element-1285" data-mp="2x2k1v3xy09r5">/yd</span></p>
        </div>
      </Link>
    </motion.div>;
}